import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/GLB_Oxxo_V4.glb";
import Refrielixia from "../../../../../assets/models/subtopicthree/Refris_Delixia_V4.glb";
import { gsap } from "gsap";
import { GUI } from "dat.gui";

export class OxxoTopicthree extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Refirs_Delixia = gltf.scene.getObjectByName("Refirs_Delixia", true);
			this.Refirs_Delixia.visible = false;
			this.Refirs_Delixia.position.y += 500;

			this.Pantallas_1 = gltf.scene.getObjectByName("Pantallas_1", true);
			//* iluminacion
			this.Mostrador001 = gltf.scene.getObjectByName("Mostrador001", true);
			this.Piso = gltf.scene.getObjectByName("Piso", true);
			this.Techo = gltf.scene.getObjectByName("Techo", true);
			this.Paredes = gltf.scene.getObjectByName("Paredes", true);
			this.Refri_coca_1 = gltf.scene.getObjectByName("Refri_coca_1", true);
			this.Estructura001 = gltf.scene.getObjectByName("Estructura001", true);
			this.Yelox = gltf.scene.getObjectByName("Yelox", true);
			this.Helado = gltf.scene.getObjectByName("Helado", true);

			const newMaterialPiso = this.Piso.material.clone();
			newMaterialPiso.color.set(0xd6d6d6);
			newMaterialPiso.emissiveIntensity = 2;
			newMaterialPiso.emissive.set("#2E2E2E");
			this.Piso.material = newMaterialPiso;
			const newMaterialTecho = this.Techo.material.clone();
			newMaterialTecho.color.set(0xffffff);
			newMaterialTecho.emissiveIntensity = 2;
			newMaterialTecho.emissive.set("#595959");
			this.Techo.material = newMaterialTecho;
			const newMaterialHelado = this.Helado.material.clone();
			newMaterialHelado.color.set(0xd1d1d1);
			newMaterialHelado.emissiveIntensity = 3.6;
			newMaterialHelado.emissive.set("#5E5E5E");
			this.Helado.material = newMaterialHelado;

			this.Paredes.material.emissiveIntensity = 2;
			this.Refri_coca_1.material.emissiveIntensity = 0.98;
			this.Yelox.material.emissiveIntensity = 2.58;
			this.Estructura001.material.emissive.set("#595959");
			this.Estructura001.material.emissiveIntensity = 1;
			this.Mostrador001.material.emissive.set("#737373");
			this.Mostrador001.material.emissiveIntensity = 2;
		});
		loader.load(Refrielixia, (gltf) => {
			this.add(gltf.scene);
			this.Break1 = gltf.scene.getObjectByName("Break1", true);
			this.Break1.defaultposition = this.Break1.position.clone();
			this.Break1001 = gltf.scene.getObjectByName("Break1001", true);
			this.Break1001.defaultposition = this.Break1001.position.clone();
			this.Break1002 = gltf.scene.getObjectByName("Break1002", true);
			this.Break1002.defaultposition = this.Break1002.position.clone();

			this.Yoplait_3 = gltf.scene.getObjectByName("Yoplait_3", true);
			this.Yoplait_3.defaultposition = this.Yoplait_3.position.clone();
			this.Yoplait_3001 = gltf.scene.getObjectByName("Yoplait_3001", true);
			this.Yoplait_3001.defaultposition = this.Yoplait_3001.position.clone();
			this.Yoplait_3002 = gltf.scene.getObjectByName("Yoplait_3002", true);
			this.Yoplait_3002.defaultposition = this.Yoplait_3002.position.clone();

			this.Lala_1 = gltf.scene.getObjectByName("Lala_1", true);
			this.Lala_1.defaultposition = this.Lala_1.position.clone();
			this.Lala_1001 = gltf.scene.getObjectByName("Lala_1001", true);
			this.Lala_1001.defaultposition = this.Lala_1001.position.clone();
			this.Lala_1002 = gltf.scene.getObjectByName("Lala_1002", true);
			this.Lala_1002.defaultposition = this.Lala_1002.position.clone();

			this.Lala_2 = gltf.scene.getObjectByName("Lala_2", true);
			this.Lala_2.defaultposition = this.Lala_2.position.clone();
			this.Lala_2001 = gltf.scene.getObjectByName("Lala_2001", true);
			this.Lala_2001.defaultposition = this.Lala_2001.position.clone();
			this.Lala_2002 = gltf.scene.getObjectByName("Lala_2002", true);
			this.Lala_2002.defaultposition = this.Lala_2002.position.clone();

			this.Danone_4 = gltf.scene.getObjectByName("Danone_4", true);
			this.Danone_4.defaultposition = this.Danone_4.position.clone();
			this.Danone_4001 = gltf.scene.getObjectByName("Danone_4001", true);
			this.Danone_4001.defaultposition = this.Danone_4001.position.clone();
			this.Danone_4002 = gltf.scene.getObjectByName("Danone_4002", true);
			this.Danone_4002.defaultposition = this.Danone_4002.position.clone();

			this.Danone_1 = gltf.scene.getObjectByName("Danone_1", true);
			this.Danone_1.defaultposition = this.Danone_1.position.clone();
			this.Danone_1002 = gltf.scene.getObjectByName("Danone_1002", true);
			this.Danone_1002.defaultposition = this.Danone_1002.position.clone();
			this.Danone_1001 = gltf.scene.getObjectByName("Danone_1001", true);
			this.Danone_1001.defaultposition = this.Danone_1001.position.clone();

			this.Activia_2 = gltf.scene.getObjectByName("Activia_2", true);
			this.Activia_2.defaultposition = this.Activia_2.position.clone();
			this.Activia_2002 = gltf.scene.getObjectByName("Activia_2002", true);
			this.Activia_2002.defaultposition = this.Activia_2002.position.clone();
			this.Activia_2001 = gltf.scene.getObjectByName("Activia_2001", true);
			this.Activia_2001.defaultposition = this.Activia_2001.position.clone();
			this.Activia_2001.material.aoMapIntensity = 0.5

			this.positionProducts = {
				Break1: this.Break1.position.clone(),
				Break1001: this.Break1001.position.clone(),
				Break1002: this.Break1002.position.clone(),
				Yoplait_3: this.Yoplait_3.position.clone(),
				Yoplait_3001: this.Yoplait_3001.position.clone(),
				Yoplait_3002: this.Yoplait_3002.position.clone(),
				Lala_2: this.Lala_2.position.clone(),
				Lala_2001: this.Lala_2001.position.clone(),
				Lala_2002: this.Lala_2002.position.clone(),
				Lala_1: this.Lala_1.position.clone(),
				Lala_1001: this.Lala_1001.position.clone(),
				Lala_1002: this.Lala_1002.position.clone(),
				Danone_4: this.Danone_4.position.clone(),
				Danone_4001: this.Danone_4001.position.clone(),
				Danone_4002: this.Danone_4002.position.clone(),
				Danone_1: this.Danone_1.position.clone(),
				Danone_1002: this.Danone_1002.position.clone(),
				Danone_1001: this.Danone_1001.position.clone(),
				Activia_2: this.Activia_2.position.clone(),
				Activia_2002: this.Activia_2002.position.clone(),
				Activia_2001: this.Activia_2001.position.clone(),
			}
		});
	}

	positionProudctSet() {
		Object.entries(this.positionProducts).forEach(([key, value]) => {
			this[key].position.copy(value)
		})
	}

	getobjectsInteractions() {
		return [
			this.Break1,
			this.Break1001,
			this.Break1002,
			this.Yoplait_3,
			this.Yoplait_3001,
			this.Yoplait_3002,
			this.Lala_2,
			this.Lala_2001,
			this.Lala_2002,
			this.Lala_1,
			this.Lala_1001,
			this.Lala_1002,
			this.Danone_4,
			this.Danone_4001,
			this.Danone_4002,
			this.Danone_1,
			this.Danone_1002,
			this.Danone_1001,
			this.Activia_2,
			this.Activia_2002,
			this.Activia_2001,
		];
	}

	animateUp(obj1, obj2, obj3, positionY) {
		if (!obj2.coloqued) {
			const timeline = gsap.timeline();
			timeline.to(obj1.position, {
				duration: 0.6,
				y: positionY,
			});
			timeline.to(
				obj2.position,
				{
					duration: 0.6,
					y: positionY,
				},
				`-=${0.5}`
			);
			timeline.to(
				obj3.position,
				{
					duration: 0.6,
					y: positionY,
				},
				`-=${0.4}`
			);
			timeline.play();
		}
	}

	animateStant(obj1, obj2, obj3, position1, position2, position3) {
		obj1.coloqued = true;
		obj2.coloqued = true;
		obj3.coloqued = true;
		const timeline = gsap.timeline();
		timeline.to(obj1.position, {
			duration: 0.6,
			x: position1.x,
			y: position1.y,
			z: position1.z,
		});
		timeline.to(
			obj2.position,
			{
				duration: 0.6,
				x: position2.x,
				y: position2.y,
				z: position2.z,
			},
			`-=${0.5}`
		);
		timeline.to(
			obj3.position,
			{
				duration: 0.6,
				x: position3.x,
				y: position3.y,
				z: position3.z,
			},
			`-=${0.4}`
		);
		timeline.play();
	}

	animateToFinalPosition(productcliked, position1, position2, position3) {
		switch (productcliked.name) {
			case "Break1":
			case "Break1001":
			case "Break1002":
				this.animateStant(this.Break1, this.Break1001, this.Break1002, position1, position2, position3);
				break;
			case "Yoplait_3":
			case "Yoplait_3001":
			case "Yoplait_3002":
				this.animateStant(this.Yoplait_3, this.Yoplait_3001, this.Yoplait_3002, position1, position2, position3);
				break;
			case "Lala_2":
			case "Lala_2001":
			case "Lala_2002":
				this.animateStant(this.Lala_2, this.Lala_2001, this.Lala_2002, position1, position2, position3);
				break;
			case "Lala_1":
			case "Lala_1001":
			case "Lala_1002":
				this.animateStant(this.Lala_1, this.Lala_1001, this.Lala_1002, position1, position2, position3);
				break;
			case "Danone_4":
			case "Danone_4001":
			case "Danone_4002":
				this.animateStant(this.Danone_4, this.Danone_4001, this.Danone_4002, position1, position2, position3);
				break;
			case "Danone_1":
			case "Danone_1002":
			case "Danone_1001":
				this.animateStant(this.Danone_1, this.Danone_1001, this.Danone_1002, position1, position2, position3);
				break;
			case "Activia_2":
			case "Activia_2002":
			case "Activia_2001":
				this.animateStant(this.Activia_2, this.Activia_2001, this.Activia_2002, position1, position2, position3);
				break;

			default:
				break;
		}
	}

	onSelectProductFeedback(name, positionY) {
		switch (name) {
			case "Break1":
			case "Break1001":
			case "Break1002":
				this.animateUp(this.Break1, this.Break1001, this.Break1002, positionY);
				break;
			case "Yoplait_3":
			case "Yoplait_3001":
			case "Yoplait_3002":
				this.animateUp(this.Yoplait_3, this.Yoplait_3001, this.Yoplait_3002, positionY);
				break;
			case "Lala_2":
			case "Lala_2001":
			case "Lala_2002":
				this.animateUp(this.Lala_2, this.Lala_2001, this.Lala_2002, positionY);
				break;
			case "Lala_1":
			case "Lala_1001":
			case "Lala_1002":
				this.animateUp(this.Lala_1, this.Lala_1001, this.Lala_1002, positionY);
				break;
			case "Danone_4":
			case "Danone_4001":
			case "Danone_4002":
				this.animateUp(this.Danone_4, this.Danone_4001, this.Danone_4002, positionY);
				break;
			case "Danone_1":
			case "Danone_1002":
			case "Danone_1001":
				this.animateUp(this.Danone_1, this.Danone_1001, this.Danone_1002, positionY);
				break;
			case "Activia_2":
			case "Activia_2002":
			case "Activia_2001":
				this.animateUp(this.Activia_2, this.Activia_2001, this.Activia_2002, positionY);
				break;

			default:
				break;
		}
	}

	defaultPosition() {
		const objects = [
			this.Break1,
			this.Break1001,
			this.Break1002,
			this.Yoplait_3,
			this.Yoplait_3001,
			this.Yoplait_3002,
			this.Lala_1,
			this.Lala_1001,
			this.Lala_1002,
			this.Lala_2,
			this.Lala_2001,
			this.Lala_2002,
			this.Danone_4,
			this.Danone_4001,
			this.Danone_4002,
			this.Danone_1,
			this.Danone_1002,
			this.Danone_1001,
			this.Activia_2,
			this.Activia_2002,
			this.Activia_2001,
		];

		for (const obj of objects) {
			obj.position.copy(obj.defaultposition);
			obj.coloqued = false;
		}
	}

	helpersMethod(name = "", object) {
		const { scale, position, rotation, material } = object;
		const gui = new GUI();
		const folderMostrador = gui.addFolder(name);
		const limit = 20;
		folderMostrador.add(scale, "x", -limit, limit).step(0.0001).name("Ancho");
		folderMostrador.add(scale, "y", -limit, limit).step(0.0001).name("Alto");

		folderMostrador.add(position, "x", -limit, limit).step(0.0001).name("Posición X");
		folderMostrador.add(position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folderMostrador.add(position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folderMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folderMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folderMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folderMostrador.add(object, "visible").name("Visible");

		folderMostrador
			.addColor({ color: material.color.getHex() }, "color")
			.name("Color del Material")
			.onChange((value) => {
				material.color.set(value);
			});

		// folderMostrador.add(this.material, "lightMapIntensity", 0, 5).name("Intensidad del mapa de luz");
		// folderMostrador.add(this.material.map.repeat, "y", -1, 1).step(0.01).name("Repetición Y del mapa de textura");
	}

	renderAnimations() { }
}
